import { memo } from 'react'
import { useTradingSummaryHashState } from '~/modules/tradeSheet/tradingAnalyzer/useTradingSummaryHashState'
import { totalProfitCss } from '~/modules/tradeSheet/tradingAnalyzer/tradingAnalyzerCss'

const MaxDrawdown = memo(function MaxDrawdown() {
  const { state } = useTradingSummaryHashState.useContainer()

  return <div css={totalProfitCss}>-{state.maxDrawdown}</div>
})

export default MaxDrawdown
